// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#basket-empty div[data-v-5a13b4c1]{margin-top:22vh;margin-bottom:22vh}#basket-empty svg[data-v-5a13b4c1]{color:#f0f0f0;width:50%;height:30%}#basket-empty h2[data-v-5a13b4c1]{color:#003c71}#order-extra-info[data-v-5a13b4c1]{background-color:#f0f0f0;border-top:1px solid #dcdcdc;border-bottom:1px solid #dcdcdc}#bundle-save[data-v-5a13b4c1],.bg-warning-light[data-v-5a13b4c1]{background-color:#ffe9a4}.disable-all[data-v-5a13b4c1]{pointer-events:none}", ""]);
// Exports
module.exports = exports;
